<salon-finder-email-notification-form [formModel]="emailNotificationForm"></salon-finder-email-notification-form>